import React, { useEffect, useState } from 'react';
import API from './services/api';

export default function HazardAcknowledgmentPublic() {
  const [token, setToken] = useState(() => {
    try {
      return new URLSearchParams(window.location.search).get('token');
    } catch (e) {
      return null;
    }
  });
  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [safetyGuidelines, setSafetyGuidelines] = useState({
    reviewedHazards: false,
    implementedControls: false,
    properPPE: false,
    emergencyProcedures: false,
    obtainedPermits: false
  });
  const [submitted, setSubmitted] = useState(false);
  const allChecked = Object.values(safetyGuidelines).every(Boolean);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    API.get(`/api/hazards/acknowledgment/${encodeURIComponent(token)}`)
      .then(res => {
        setInvitation(res.data.invitation || res.data);
      })
      .catch(err => {
        console.error('Invalid or expired token', err);
        setInvitation(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setSafetyGuidelines(prev => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async () => {
    if (!token) return;
    try {
      await API.post(`/api/hazards/acknowledgment/${encodeURIComponent(token)}`, { safetyGuidelines });
      setSubmitted(true);
    } catch (err) {
      console.error('Failed to submit acknowledgment', err);
      alert('Failed to submit acknowledgment. Please try again.');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!token) return <div>Invalid link</div>;
  if (!invitation) return <div>Invitation not found or expired.</div>;
  if (submitted) return <div>Thank you — your acknowledgement has been recorded.</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Pre-job Hazard Acknowledgement</h2>
      <p>Please confirm the following:</p>
      <div>
        <label>
          <input type="checkbox" name="reviewedHazards" checked={safetyGuidelines.reviewedHazards} onChange={handleChange} /> Reviewed all identified hazards with your team
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" name="implementedControls" checked={safetyGuidelines.implementedControls} onChange={handleChange} /> Implemented appropriate control measures
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" name="properPPE" checked={safetyGuidelines.properPPE} onChange={handleChange} /> Confirmed all workers have proper PPE and training
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" name="emergencyProcedures" checked={safetyGuidelines.emergencyProcedures} onChange={handleChange} /> Established emergency response procedures
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" name="obtainedPermits" checked={safetyGuidelines.obtainedPermits} onChange={handleChange} /> Obtained all necessary permits and authorizations
        </label>
      </div>

      <div style={{ marginTop: 16 }}>
        <button disabled={!allChecked} onClick={handleSubmit}>Acknowledge</button>
      </div>
    </div>
  );
}
